import { Link } from "@caprikorn/dynamo-ui";
import { classNames } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import classes from "./InfoItem.module.css";
import type { InfoItemProps } from "./InfoItem.types";

export const InfoItem: FC<InfoItemProps> = ({
  name,
  value,
  link,
  isEmail,
  subtitle,
  className,
}) => (
  <li className={classNames(classes.container, className)}>
    <span className="font-label-default">{name}</span>
    {link && value ? (
      <Link
        className={classNames(classes.itemValue, "font-label-highlight")}
        href={isEmail ? `mailto:${value}` : value}
      >
        {value}
      </Link>
    ) : (
      <span className={classNames(classes.itemValue, "font-label-highlight")}>
        {value}
      </span>
    )}
    {subtitle && (
      <span className={classNames(classes.itemValue, "font-label-highlight")}>
        {subtitle}
      </span>
    )}
  </li>
);
